module.exports = __webpack_public_path__ + "img/official_accounts_website_qrcode.d0be5e10.png";